var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("Значение")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.value,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "value")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("Метка")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.label,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "label")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }